import { SET_CONTACT_US_RESULT } from './constants';

const initialState = {
  success: null,
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_CONTACT_US_RESULT:
      return {
        ...state,
        success: action.payload,
      };
    default:
      return state;
  }
};

export default reducer;
